import { API } from "aws-amplify";
import { getYearRecords } from "~/graphql/queries";
import * as APITypes from "~/API";

export const EMPTY_YEAR_RECORD: APITypes.YearRecords = {
  __typename: "YearRecords",
  id: "",
  ownerID: "",
  ownerType: APITypes.OwnerType.User,
  createdAt: "",
  updatedAt: "",
  _version: 0,
  _lastChangedAt: 0,
};

export const getYearRecordsDetais = async (recordId: string) => {
  try {
    const response = (await API.graphql({
      query: getYearRecords,
      variables: {
        id: recordId,
      },
    })) as { data?: APITypes.GetYearRecordsQuery };

    return {
      success: true,
      data: response.data?.getYearRecords || EMPTY_YEAR_RECORD,
    };
  } catch (error) {
    console.error("failed to get yearly records", error);
    return {
      success: false,
      data: EMPTY_YEAR_RECORD,
      error,
    };
  }
};
